import React, { Fragment, useState, useEffect } from 'react'
import { Table, Form, Row, Col, InputGroup, Container, Button, Alert } from 'react-bootstrap'
import Select from 'react-select'
import CurrencyInput from 'react-currency-input'
import { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import ptBr from 'date-fns/locale/pt-BR'
import moment from 'moment'
import { toast } from 'react-toastify'

import OrtodontiaService from '../../../../services/ortodontia.service'
import { formatMoney, handleDecimalConvert } from '../../../../utils/string.utils'
import { gerarParcelasPagamento } from '../../../../utils/parcelamento.utils'
import { parcelasSelect } from '../../../../constants/agendamento.constants'
import { MSG_LIMITE_RENEGOCIACOES } from '../../../../constants/common.constants'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'

registerLocale('pt-BR', ptBr)

export default function Financeiro({ nextStep, setPagamento, setIsLoading, selectedPlano, parcelasEmAberto, resetInitialState }) {
  const [totalPagamento, setTotalPagamento] = useState(0.0)
  const [valorEntrada, setValorEntrada] = useState(selectedPlano.minEntrada)
  const [valorParcelamento] = useState(totalPagamento / parcelasSelect[0].value)
  const [parcelamentoSelecionado, setParcelamentoSelecionado] = useState(parcelasSelect[0])
  const [parcelas, setParcelas] = useState([])
  const [dataVencimento, setDataVencimento] = useState(moment())
  const [minEntrada] = useState(selectedPlano.minEntrada)

  useEffect(() => {
    calcularTotalParcelasEmAberto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parcelasEmAberto])

  const handleDataVencimento = (data) => {
    if (moment() > data)
      data = moment()

    setDataVencimento(data)
  }

  useEffect(() => {
    const valorEntradaNumber = handleDecimalConvert(valorEntrada)
    if (valorEntradaNumber >= totalPagamento) {
      setValorEntrada(formatMoney(totalPagamento).substring(3))
      setParcelamento(parcelasSelect[0])
      return
    }

    const parcelasCalculadas = gerarParcelasPagamento({
      totalPagamento,
      valorEntradaNumber,
      numeroParcelas: parcelamentoSelecionado.value,
      dataVencimento,
    })

    setParcelas(parcelasCalculadas)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valorEntrada, totalPagamento, parcelamentoSelecionado, dataVencimento])

  const calcularTotalParcelasEmAberto = () => {
    let soma = 0
    parcelasEmAberto.forEach((p) => {
      if (p.valorCalculado > p.valor) {
        soma += p.valorCalculado
      } else {
        soma += p.valor
      }
    })
    setTotalPagamento(soma)
  }

  const salvarRenegociacao = async () => {
    if (!selectedPlano.comParceiroFinanceiro && selectedPlano.atingiuLimiteRenegociacoes) {
      toast(MSG_LIMITE_RENEGOCIACOES, { type: toast.TYPE.WARNING })
      return
    }

    setIsLoading(true)
    try {
      const pagamentoRenegociado = {
        valorTotal: Number(totalPagamento.toFixed(2)),
        dataVencimento: dataVencimento.toISOString(),
        numeroParcelas: parcelas.length,
        parcelas,
      }
      setPagamento(pagamentoRenegociado)
      await OrtodontiaService.salvarRenegociacao(parcelasEmAberto, pagamentoRenegociado)
      resetInitialState()
      nextStep()
    } catch (e) {
      console.error(e)
    }
    setIsLoading(false)
  }

  const setEntrada = (valor) => {
    if (selectedPlano.comParceiroFinanceiro)
      return setValorEntrada(valor);

    // Buscar minimo de entrada e validar, não deixar setar o menor valor.
    if (handleDecimalConvert(valor) < minEntrada)
      return toast(`Valor da entrada está abaixo do estipulado pela unidade, o valor minimo de entrada é: R$ ${selectedPlano.minEntrada}`, { type: toast.TYPE.WARNING });

    setValorEntrada(valor)
  }

  const setParcelamento = (parcelas) => setParcelamentoSelecionado(parcelas)

  return (
    <div className='d-flex'>
      <Container className='pb-5' style={{ maxWidth: 750 }}>
        {!selectedPlano.comParceiroFinanceiro && selectedPlano.atingiuLimiteRenegociacoes && (
          <Alert variant='warning' className='mt-4'>
            {MSG_LIMITE_RENEGOCIACOES}
          </Alert>
        )}
        {parcelasEmAberto.length > 0 ? (
          <Fragment>
            <h4 className='mb-4 text-secondary font-weight-bold'>Parcelas em Aberto</h4>
            <Table bordered hover className='mb-5'>
              <thead>
                <tr>
                  <th className='text-center' width='100px'>
                    Parcela
                  </th>
                  <th className='text-center'>Vencimento</th>
                  <th className='text-center'>Valor</th>
                </tr>
              </thead>
              <tbody>
                {parcelasEmAberto.map((p, index) => (
                  <tr key={index}>
                    <td className='text-center'>{p.parcela}</td>
                    <td className='text-center'>{moment(p.dataVencimento).format(`DD/MM/YYYY`)}</td>
                    <td className={`text-center font-weight-bold ${p.valorCalculado > p.valor && 'text-danger'}`}>
                      {p.valorCalculado > p.valor ? formatMoney(p.valorCalculado) : formatMoney(p.valor)}
                    </td>
                  </tr>
                ))}
                <tr className='bg-secondary-03'>
                  <td className='text-center font-weight-bold'>Total:</td>
                  <td className='text-center font-weight-bold'></td>
                  <td className='text-center font-weight-bold'>{formatMoney(totalPagamento)}</td>
                </tr>
              </tbody>
            </Table>
          </Fragment>
        ) : (
          <h4 className='mb-4 text-secondary font-weight-bold'>Nenhuma parcela em aberto</h4>
        )}
        {parcelasEmAberto.length > 0 && (
          <Fragment>
            <h4 className='my-4 text-secondary font-weight-bold'>Condições de pagamento</h4>
            <Row>
              <Form.Group as={Col} className='col-md-5'>
                <Form.Label>Primeira parcela</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>R$</InputGroup.Text>
                  </InputGroup.Prepend>
                  <CurrencyInput
                    className='form-control'
                    decimalSeparator=','
                    thousandSeparator='.'
                    value={valorEntrada}
                    minValue={1}
                    onChange={setEntrada}
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group as={Col} className='col-md-2'>
                <Form.Label>Parcelas</Form.Label>
                <Select value={parcelamentoSelecionado} options={parcelasSelect} onChange={setParcelamento} />
              </Form.Group>

              <Form.Group as={Col} className='col-md-5 required'>
                {selectedPlano.comParceiroFinanceiro ?
                  <>
                    <Form.Label>Data da Primeira parcela</Form.Label>
                    <MuiPickersUtilsProvider utils={MomentUtils} locale='pt-br'>
                      <KeyboardDatePicker
                        id='dataPrimeiraParcela'
                        name='dataPrimeiraParcela'
                        className='form-control'
                        invalidDateMessage='Formato de data inválido'
                        onChange={handleDataVencimento}
                        value={dataVencimento}
                        variant='inline'
                        format='DD/MM/YYYY'
                        required
                        autoOk
                        animateYearScrolling
                        disablePast
                      />
                    </MuiPickersUtilsProvider>
                  </>
                  :
                  <>
                    <Form.Label>Data da Primeira parcela</Form.Label>
                    <input className='form-control' disabled={!selectedPlano.comParceiroFinanceiro} type='text' value={dataVencimento.format("DD/MM/YYYY")} />
                  </>
                }
              </Form.Group>
            </Row>
            {valorParcelamento <= totalPagamento && (
              <div>
                <h4 className='my-4 text-secondary font-weight-bold'>Resumo do Parcelamento</h4>
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th className='text-center' width='100px'>
                        Parcela
                      </th>
                      <th className='text-center'>Vencimento</th>
                      <th className='text-center' width='250px'>
                        Valor
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {parcelas.map(({ numero, dataVencimento, valor }, index) => (
                      <tr key={index}>
                        <td className='text-center'>{numero}</td>
                        <td className='text-center'>
                          {dataVencimento ? moment(dataVencimento).format(`DD/MM/YYYY`) : 'Data Inválida'}
                        </td>
                        <td className='text-center'>{formatMoney(valor)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {selectedPlano.comParceiroFinanceiro || handleDecimalConvert(valorEntrada) >= minEntrada ?
                  <Button className='mt-3 ml-auto d-block' onClick={salvarRenegociacao} variant='primary'>
                    Salvar Renegociação
                  </Button>
                  :
                  <Button className='mt-3 ml-auto d-block' disabled={true} variant='primary'>
                    Salvar Renegociação
                  </Button>
                }

              </div>
            )}
          </Fragment>
        )}
      </Container>
    </div>
  )
}
